import React from 'react';
import { Section } from '../../shared';
import SubjectsSection from './components/SubjectsSection';
import DateRangesSection from './components/DateRangesSection';
import BenchmarksSection from './components/BenchmarksSection';
import { Separator } from '@/components/ui/separator';
import { hasDisabledBenchmark, hasDisabledDateRange, hasDisabledSubjectInputs, useHasFF } from 'venn-utils';
import { WarningNote } from 'venn-ui-kit';
import { useRecoilValue, waitForAll } from 'recoil';
import { blockSettings, selectedBlocksState } from 'venn-state';
import { DismissableInputTutorial } from './components/DismissableInputTutorial';

const InputsPanel = () => {
  const hasPortfolioFiltering = useHasFF('block_assignment_ff');

  const selectedBlocks = useRecoilValue(selectedBlocksState);
  const allBlockSettings = useRecoilValue(waitForAll(selectedBlocks.map((id) => blockSettings(id))));
  const selectionDoesNotSupportSubjects = allBlockSettings.some(
    ({ customBlockType }) =>
      hasDisabledSubjectInputs(customBlockType) &&
      hasDisabledBenchmark(customBlockType, undefined) &&
      hasDisabledDateRange(customBlockType),
  );

  return (
    <>
      {hasPortfolioFiltering && <DismissableInputTutorial />}
      {hasPortfolioFiltering && selectionDoesNotSupportSubjects && (
        <>
          <WarningNote size="small">
            Formatting blocks cannot have inputs assigned to them. Deselect any Custom Text and Image blocks or select a
            different block.
          </WarningNote>
          <Separator className="bg-venn-grey-30" />
        </>
      )}
      <SubjectsSection />
      {hasPortfolioFiltering ? <Separator className="bg-venn-grey-30 mt-[32px]" /> : <Section />}
      <DateRangesSection />
      {hasPortfolioFiltering ? <Separator className="bg-venn-grey-30 mt-[32px]" /> : <Section />}
      <BenchmarksSection />
      {!hasPortfolioFiltering && <Section noBorder />}
    </>
  );
};

export default InputsPanel;
